import { useState } from "react";
import { IMG, QUALITY_POINTS } from "@/lib/content";
import { Reveal, MaskedLines, ImageReveal } from "@/components/motion/Reveal";

export function Quality() {
  const [active, setActive] = useState(0);
  return (
    <section className="bg-white py-28 md:py-40" aria-labelledby="quality-title">
      <div className="container-x grid lg:grid-cols-12 gap-14 lg:gap-8">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="label text-mute mb-6 flex items-center gap-4"><span className="w-6 h-px bg-ink/40" /> 06 · Qualität</p>
          </Reveal>
          <MaskedLines as="h2" id="quality-title" lines={["Der Unterschied", "liegt im Detail."]} className="display text-4xl sm:text-5xl lg:text-6xl text-ink" />
          <div className="mt-14 grid grid-cols-12 gap-4">
            <ImageReveal src={IMG.quality.stone} alt="Natursteinoberfläche im Detail" className="col-span-7 aspect-[4/5]" />
            <ImageReveal src={IMG.quality.glass} alt="Klare Glasfläche mit Lichtreflexion" className="col-span-5 aspect-[4/5] mt-16" delay={0.15} />
            <ImageReveal src={IMG.quality.kitchen} alt="Küchenoberfläche in Stein und Holz" className="col-span-5 aspect-square -mt-10" delay={0.1} />
            <ImageReveal src={IMG.quality.wood} alt="Holzoberfläche im Detail" className="col-span-7 aspect-[16/10] mt-6" delay={0.2} />
          </div>
        </div>

        <div className="lg:col-span-6 lg:col-start-7 lg:pt-28">
          <ol className="border-t border-line">
            {QUALITY_POINTS.map((q, i) => (
              <Reveal as="li" key={q.t} delay={i * 0.06} className="border-b border-line">
                <button
                  type="button"
                  onMouseEnter={() => setActive(i)}
                  onClick={() => setActive(i)}
                  data-testid={`quality-point-${i + 1}`}
                  className="w-full text-left grid grid-cols-[3rem_1fr] gap-4 py-6 group"
                >
                  <span className={`label pt-1 transition-colors duration-500 ${active === i ? "text-signal" : "text-mute"}`}>0{i + 1}</span>
                  <span>
                    <span className={`display block text-2xl md:text-3xl transition-transform duration-700 ease-out ${active === i ? "translate-x-2" : ""}`}>{q.t}</span>
                    <span className={`block overflow-hidden transition-[max-height,opacity] duration-700 ease-out ${active === i ? "max-h-24 opacity-100 mt-3" : "max-h-0 opacity-0"}`}>
                      <span className="text-sm md:text-base text-mute leading-relaxed">{q.d}</span>
                    </span>
                  </span>
                </button>
              </Reveal>
            ))}
          </ol>
          <Reveal delay={0.3} className="mt-12">
            <p className="text-sm text-mute leading-relaxed max-w-md">Zuverlässig geplant. Sorgfältig ausgeführt. Wir reinigen, Sie müssen sich um nichts kümmern.</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
